<template>
  <div v-if="emojiReactions && emojiReactions.length > 0" class="emoji-reactions">
    <UserListPopover v-for="(reaction) in emojiReactions"
      :key="reaction.url || reaction.name"
      :users="accountsForEmoji[reaction.url || reaction.name]">
      <button class="emoji-reaction btn button-default"
        :class="{ 'picked-reaction': reactedWith(reaction.name), 'not-clickable': !loggedIn }"
        @click.stop.prevent="emojiOnClick(reaction.name, $event)"
        @mouseenter="fetchEmojiReactionsByIfMissing()">
        <template v-if="reaction.url !== null">
          <StillImage
          :src="reaction.url"
          :title="reaction.name"
          :alt="reaction.name"
          class="reaction-emoji"/>
        </template>
        <template v-else>
          <span class="reaction-emoji">{{ reaction.name }}</span>
        </template>
        <span class="count">{{ reaction.count }}</span>
      </button>
    </UserListPopover>
    <a v-if="tooManyReactions"
      class="emoji-reaction-expand faint"
      href="javascript:void(0)"
      @click.stop.prevent="toggleShowAll">
    {{ showAll ? $t('general.show_less') : showMoreString }}
    </a>
  </div>
</template>

<script src="./emoji_reactions.js"></script>
<style lang="scss">
@import "../../_variables.scss";
.emoji-reactions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.2em;
  margin-top: var(--status-margin, 0.75em);
  container-type: inline-size;
}
.emoji-reaction {
  position: relative;
  padding: 4px 4px;
  display: flex;
  box-sizing: border-box;
  .reaction-emoji {
    height: 38px;
    width: auto;
    max-width: 96cqw;
    min-width: 40px;
    font-size: 32px;
    img { height: 35px; font-size: 12px; }
  }
  &:focus { outline: none; }
  &.not-clickable {
    cursor: default;
    &:hover {
      box-shadow: $fallback--buttonShadow;
      box-shadow: var(--buttonShadow);
    }
  }
  .count {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
.emoji-reaction-expand {
  padding: 0 0.5em;
  margin-right: 0.5em;
  margin-top: 0.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover { text-decoration: underline; }
}
.button-default.picked-reaction {
  &,
  &:hover {
    box-shadow: inset 0 0 0 1px var(--accent, $fallback--link);
  }
}
</style>
